import React from "react";
//import ReactDOM from 'react-dom';
import Modal from "./Modal";
import { Translate } from "react-redux-i18n";

var QRCode = require("qrcode.react");

function ModalWhatSappQr(props) {
  return (
    <Modal
      isOpen={props.isOpen}
      onClose={props.onClose}
      title="Escanea codigo Qr"
    >
      <div className="modal-body text-center">
        <QRCode value={`https://wa.me/${props.item}`} />
        <br />
        <a href={`https://wa.me/${props.item}?text=Quisiera saber más`} className="" target="_blank">Link WhatsappWeb </a>
      </div>
      <div className="modal-footer">
        <div className="col-12 text-center">
          <button class="btn btn-primary" onClick={props.onClose}>
            <i className="fa fa-close"></i>
            <Translate value="ok" />
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default ModalWhatSappQr;
